/* GUINOT — AJAX add to cart + right-hand cart drawer with upsell.
   - Intercepts every product form (form[action*="/cart/add"]) and every [data-quick-add] button
   - Opens the drawer with the cart, a free-shipping progress bar, and recommendations
   - Header cart icon (.gh__icon--cart) opens the drawer instead of navigating
*/
(function () {
  'use strict';

  var root = document.querySelector('[data-gcd]');
  if (!root) return;
  var cfg = {};
  try { cfg = JSON.parse(document.querySelector('[data-gcd-config]').textContent); } catch (e) { return; }

  var panel = root.querySelector('.gcd__panel');
  var el = function (sel) { return root.querySelector(sel); };
  var itemsEl = el('[data-gcd-items]');
  var emptyEl = el('[data-gcd-empty]');
  var footEl = el('[data-gcd-foot]');
  var shipEl = el('[data-gcd-ship]');
  var upsellEl = el('[data-gcd-upsell]');
  var upsellList = el('[data-gcd-upsell-list]');
  var noticeEl = el('[data-gcd-notice]');
  var lastFocus = null;
  var lastProductId = null;
  var busy = false;

  /* ---------- helpers ---------- */
  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }
  function fmtNum(cents, dec, thou, sep) {
    var n = (cents / 100).toFixed(dec);
    var parts = n.split('.');
    parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, thou);
    return parts[1] ? parts[0] + sep + parts[1] : parts[0];
  }
  function money(cents) {
    var f = cfg.moneyFormat || '{{amount}}';
    return f.replace(/\{\{\s*(\w+)\s*\}\}/, function (_, k) {
      switch (k) {
        case 'amount_no_decimals': return fmtNum(cents, 0, ',', '.');
        case 'amount_with_comma_separator': return fmtNum(cents, 2, '.', ',');
        case 'amount_no_decimals_with_comma_separator': return fmtNum(cents, 0, '.', ',');
        case 'amount_with_space_separator': return fmtNum(cents, 2, ' ', ',');
        case 'amount_no_decimals_with_space_separator': return fmtNum(cents, 0, ' ', ',');
        case 'amount_with_apostrophe_separator': return fmtNum(cents, 2, "'", '.');
        default: return fmtNum(cents, 2, ',', '.');
      }
    }).replace(/<[^>]*>/g, '');
  }
  function img(url, w) {
    if (!url) return '';
    if (typeof url === 'object') url = url.url || url.src || '';
    if (url.indexOf('//') === 0) url = 'https:' + url;
    return url + (url.indexOf('?') > -1 ? '&' : '?') + 'width=' + w;
  }
  function json(url, opts) {
    return fetch(url, Object.assign({ headers: { 'Accept': 'application/json', 'Content-Type': 'application/json' } }, opts || {}))
      .then(function (r) { return r.json().then(function (d) { if (!r.ok) throw d; return d; }); });
  }

  /* ---------- open / close ---------- */
  function open() {
    if (!root.hidden && root.classList.contains('is-open')) return;
    lastFocus = document.activeElement;
    root.hidden = false;
    document.documentElement.classList.add('gcd-lock');
    requestAnimationFrame(function () { root.classList.add('is-open'); panel.focus({ preventScroll: true }); });
  }
  function close() {
    root.classList.remove('is-open');
    document.documentElement.classList.remove('gcd-lock');
    setTimeout(function () { root.hidden = true; }, 320);
    if (lastFocus && lastFocus.focus) lastFocus.focus();
  }
  root.querySelectorAll('[data-gcd-close]').forEach(function (b) { b.addEventListener('click', close); });
  document.addEventListener('keydown', function (e) {
    if (root.hidden) return;
    if (e.key === 'Escape') close();
    if (e.key === 'Tab') {
      var f = panel.querySelectorAll('a[href], button:not([disabled]), input, [tabindex]:not([tabindex="-1"])');
      if (!f.length) return;
      var first = f[0], last = f[f.length - 1];
      if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
      else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
    }
  });

  function notice(msg) {
    if (!msg) { noticeEl.hidden = true; return; }
    noticeEl.textContent = msg; noticeEl.hidden = false;
  }

  /* ---------- render ---------- */
  function updateBubble(count) {
    document.querySelectorAll('.gh__icon--cart').forEach(function (a) {
      var b = a.querySelector('.gh__cart-bub');
      if (count > 0) {
        if (!b) { b = document.createElement('span'); b.className = 'gh__cart-bub'; b.setAttribute('aria-live', 'polite'); a.appendChild(b); }
        b.textContent = count;
      } else if (b) { b.remove(); }
      a.setAttribute('aria-label', 'Panier (' + count + ')');
    });
  }

  function renderCart(cart) {
    el('[data-gcd-count]').textContent = cart.item_count ? '(' + cart.item_count + ')' : '';
    updateBubble(cart.item_count);
    var empty = !cart.item_count;
    emptyEl.hidden = !empty;
    footEl.hidden = empty;
    itemsEl.innerHTML = cart.items.map(function (it) {
      var variant = it.variant_title && it.variant_title !== 'Default Title' ? '<span class="gcd__variant">' + esc(it.variant_title) + '</span>' : '';
      var was = it.original_line_price > it.final_line_price ? '<s>' + money(it.original_line_price) + '</s>' : '';
      return '<li class="gcd__item" data-key="' + esc(it.key) + '">' +
        '<a class="gcd__thumb" href="' + esc(it.url) + '">' + (it.image ? '<img src="' + esc(img(it.image, 180)) + '" alt="" width="90" height="112" loading="lazy">' : '') + '</a>' +
        '<div class="gcd__info">' +
          '<a class="gcd__name" href="' + esc(it.url) + '">' + esc(it.product_title) + '</a>' + variant +
          '<div class="gcd__row">' +
            '<div class="gcd__qty" role="group" aria-label="Quantité">' +
              '<button type="button" data-qty="' + (it.quantity - 1) + '" aria-label="Diminuer">−</button>' +
              '<span aria-live="polite">' + it.quantity + '</span>' +
              '<button type="button" data-qty="' + (it.quantity + 1) + '" aria-label="Augmenter">+</button>' +
            '</div>' +
            '<span class="gcd__price">' + was + money(it.final_line_price) + '</span>' +
          '</div>' +
          '<button type="button" class="gcd__remove" data-qty="0">Retirer</button>' +
        '</div></li>';
    }).join('');
    el('[data-gcd-subtotal]').textContent = money(cart.total_price);

    // free shipping progress
    if (cfg.threshold > 0 && !empty) {
      var left = cfg.threshold - cart.total_price;
      shipEl.hidden = false;
      el('[data-gcd-ship-text]').innerHTML = left > 0
        ? 'Plus que <strong>' + money(left) + '</strong> pour profiter de la livraison offerte'
        : 'Vous bénéficiez de la <strong>livraison offerte</strong>';
      el('[data-gcd-ship-fill]').style.width = Math.min(100, Math.round(cart.total_price / cfg.threshold * 100)) + '%';
      shipEl.classList.toggle('is-done', left <= 0);
    } else {
      shipEl.hidden = true;
    }
    return cart;
  }

  function renderUpsell(cart) {
    var pid = lastProductId || (cart.items[0] && cart.items[0].product_id);
    if (!pid || !cfg.routes.recommendations) { upsellEl.hidden = true; return; }
    var inCart = {};
    cart.items.forEach(function (it) { inCart[it.product_id] = true; });
    var url = function (intent) { return cfg.routes.recommendations + '?product_id=' + pid + '&limit=8&intent=' + intent; };
    json(url('complementary')).then(function (d) {
      var list = (d.products || []).filter(function (p) { return p.available && !inCart[p.id]; });
      if (list.length >= 2) return list;
      return json(url('related')).then(function (r) {
        var ids = {}; list.forEach(function (p) { ids[p.id] = true; });
        return list.concat((r.products || []).filter(function (p) { return p.available && !inCart[p.id] && !ids[p.id]; }));
      });
    }).then(function (list) {
      list = list.slice(0, 3);
      if (!list.length) { upsellEl.hidden = true; return; }
      upsellList.innerHTML = list.map(function (p) {
        var v = (p.variants || []).filter(function (x) { return x.available; })[0] || p.variants[0];
        return '<li class="gcd__up">' +
          '<a class="gcd__up-thumb" href="' + esc(p.url) + '"><img src="' + esc(img(p.featured_image, 180)) + '" alt="" width="72" height="90" loading="lazy"></a>' +
          '<div class="gcd__up-info"><a class="gcd__up-name" href="' + esc(p.url) + '">' + esc(p.title) + '</a>' +
          '<span class="gcd__up-price">' + money(v ? v.price : p.price) + '</span></div>' +
          '<button type="button" class="gcd__up-add" data-quick-add="' + (v ? v.id : '') + '" data-product-id="' + p.id + '" aria-label="Ajouter ' + esc(p.title) + ' au panier">Ajouter</button>' +
          '</li>';
      }).join('');
      upsellEl.hidden = false;
    }).catch(function () { upsellEl.hidden = true; });
  }

  function refresh() {
    return json(cfg.routes.cart).then(renderCart).then(function (cart) { renderUpsell(cart); return cart; });
  }

  /* ---------- cart mutations ---------- */
  function add(items, productId) {
    if (busy) return Promise.resolve();
    busy = true; notice('');
    return json(cfg.routes.cartAdd, { method: 'POST', body: JSON.stringify({ items: items }) })
      .then(function (d) {
        var added = d && d.items && d.items[0];
        lastProductId = productId || (added && added.product_id) || lastProductId;
        return refresh();
      })
      .then(function () { open(); })
      .catch(function (err) {
        open(); refresh();
        notice((err && (err.description || err.message)) || 'Ce produit n’a pas pu être ajouté. Veuillez réessayer.');
      })
      .finally(function () { busy = false; });
  }
  function change(key, qty) {
    root.classList.add('is-busy');
    return json(cfg.routes.cartChange, { method: 'POST', body: JSON.stringify({ id: key, quantity: qty }) })
      .then(renderCart).then(renderUpsell)
      .catch(function (err) { notice((err && err.description) || 'Mise à jour impossible.'); refresh(); })
      .finally(function () { root.classList.remove('is-busy'); });
  }

  itemsEl.addEventListener('click', function (e) {
    var b = e.target.closest('[data-qty]'); if (!b) return;
    var li = b.closest('[data-key]');
    change(li.getAttribute('data-key'), Math.max(0, parseInt(b.getAttribute('data-qty'), 10)));
  });

  /* Product forms (PDP, sticky bar via requestSubmit, any theme form) */
  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!form || !form.matches || !form.matches('form[action*="/cart/add"]')) return;
    e.preventDefault();
    var fd = new FormData(form);
    var id = fd.get('id');
    if (!id) return;
    var qty = parseInt(fd.get('quantity') || '1', 10) || 1;
    add([{ id: Number(id), quantity: qty }], null).then(function () {
      // give the PDP button back its normal state
      var btn = form.querySelector('[data-gp-add], [type="submit"][name="add"]');
      if (btn) {
        btn.disabled = false;
        var lbl = btn.querySelector('[data-gp-add-label]');
        if (lbl) lbl.textContent = 'Ajouter au panier';
      }
    });
  }, true);

  /* Quick add buttons (product cards, upsell) */
  document.addEventListener('click', function (e) {
    var b = e.target.closest('[data-quick-add]');
    if (!b) return;
    e.preventDefault(); e.stopPropagation();
    var vid = b.getAttribute('data-quick-add');
    if (!vid) return;
    b.classList.add('is-loading'); b.disabled = true;
    add([{ id: Number(vid), quantity: 1 }], b.getAttribute('data-product-id')).then(function () {
      b.classList.remove('is-loading'); b.disabled = false;
    });
  });

  /* Header cart icon opens the drawer (except on the cart page itself) */
  document.addEventListener('click', function (e) {
    var a = e.target.closest('.gh__icon--cart');
    if (!a || e.metaKey || e.ctrlKey) return;
    if (window.location.pathname.replace(/\/$/, '') === String(cfg.routes.cartPage).replace(/\/$/, '')) return;
    e.preventDefault();
    refresh().then(open);
  });
})();
